const Platforms = {
    CLIENT: 'js',
    SERVER: 'browserless',
} as const;

export function getEventPlatform() {
    if (process.env.CLIENT) {
        return Platforms.CLIENT;
    }

    return Platforms.SERVER;
}
